import type { CreateSdkParams } from "@/utils/createAgentSdk";

import { useDataKeysStore } from "@/encryption";
import { useChatStore } from "@/sdk";

export function getStatelessCacheActions(): Pick<CreateSdkParams, "chatMessagesCache" | "dataKeysCache"> {
    const addDataKey = useDataKeysStore.getState().addDataKey;
    const removeDataKey = useDataKeysStore.getState().removeDataKey;
    const findDataKeyByContext = useDataKeysStore.getState().findDataKeyByContext;
    const findDataKeyByEncryptionKey = useDataKeysStore.getState().findDataKeyByEncryptionKey;

    const addChatMessages = useChatStore.getState().addChatMessages;
    const removeChat = useChatStore.getState().removeChat;
    const updateChatMessages = useChatStore.getState().updateChatMessages;

    const markCustomerIsTyping = useChatStore.getState().markCustomerIsTyping;
    const markCustomerStoppedTyping = useChatStore.getState().markCustomerStoppedTyping;

    return {
        dataKeysCache: {
            addDataKey,
            removeDataKey,
            findDataKeyByContext,
            findDataKeyByEncryptionKey,
        },
        chatMessagesCache: {
            addChatMessages,
            removeChat,
            updateChatMessages,
            markCustomerIsTyping,
            markCustomerStoppedTyping,
        },
    };
}
